import { Route } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';

/** Placeholder (gitaumoses4/chukua#39) — trip planning and assignment arrive with dispatch (M3); not empty by accident, not broken either. */
export function JobTripsTab() {
  return <EmptyState icon={Route} title="No trips yet" description="Trip planning and assignment arrive with dispatch — nothing to show here yet." />;
}
